import React, { useState } from 'react';
import { IStatsWithTitleProps } from "../../models/stats";
import { Typography } from "@mui/material";
import { BsInfoCircle } from 'react-icons/bs';
import { Popup } from '@fluentui/react';
import Modal from 'react-modal';
import styles from "./PatientBarChart.module.css";

const FormatNumber = (num:number) => {
    return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : 0;
}


//idea per variabilizzare le info mostrate dalla info circle: creare una funzione o comunque una sequenza di if che controllano la variabile title e restituiscono il testo corretto
const PatientCount: React.FC<IStatsWithTitleProps> = (props) => {
  const {stats, title} = props;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [infoText, setInfoText] = useState<React.ReactNode>(null); // Lo rendo di tipo ReactNode per far mostrare la formattazione come desiderata e non come stringa
  const [indicatorTitle, setIndicatorTitle] = useState('');

  const handleInfoClick = (infoText: React.ReactNode, title: string) => {
    setInfoText(infoText);
    setIndicatorTitle(title);
    setIsModalOpen(true);
  };


  interface InfoModalProps {
    isOpen: boolean;
    onClose: () => void;
  }

  const InfoModal = ({ isOpen, onClose }: InfoModalProps) => {
    const customStyles = {
      content: {
        top: '30px',
        right: '10%',
        bottom: 'auto',
        left: 'auto',
        maxWidth: '500px', // Aggiungi questa proprietà per limitare la larghezza del modale
      },
    };
    return (
      <Modal isOpen={isOpen} onRequestClose={onClose} style={customStyles} contentLabel="Informazioni sul tasso di politerapia">
        <div className={styles.modalContent}>
          <h2>{indicatorTitle}</h2>
          <div className={styles.infoText}>{infoText}</div>
        </div>
      </Modal>
    );
  };

  
  const indicatorsInfo = {
    'informazioni-dati': {
      title: 'Informazioni sui dati mostrati',
      infoText: <div>Nella colonna a destra della pagina principale di iCareMap sono presentati dati numerici e grafici relativi ai pazienti presenti all'interno dell'attuale livello di zoom sulla mappa (”vista”) oppure di una particolare area selezionata con il mouse (”selezione”). I riferimenti temporali (es.: “ultimi 12 mesi”) fanno riferimento ad archi di tempo calcolati sull'ultimo aggiornamento disponibile (es.: 12 mesi precedenti all'ultimo aggiornamento).<br/><br/> <b>PAZIENTI (VISTA)</b> - Pazienti in vita residenti nei comuni coperti da ASL4 e compresi sulla mappa nell'attuale livello di zoom. <br/><br/> <b>EMICRANICI (VISTA)</b> - Pazienti che presentano almeno una delle seguenti condizioni: prescrizione negli ultimi 12 mesi di farmaco con Codice ATC N02C* (farmaceutica convenzionata); consegna negli ultimi 12 mesi di farmaco con Codice ATC N02C* (farmaceutica diretta); diagnosi principale o secondaria negli ultimi 12 mesi (si considera la data di dimissione) con Codice ICD-9_CM 346** (SDO).<br/><br/> <b>DIABETICI (VISTA)</b> - Pazienti che presentano almeno una delle seguenti condizioni: prescrizione negli ultimi 12 mesi di farmaco con Codice ATC A10** (farmaceutica convenzionata); consegna negli ultimi 12 mesi di farmaco con Codice ATC A10** (farmaceutica diretta); esenzione con Codice 013.* (diabete) in corso di validità; ricevuta diagnosi principale o secondaria negli ultimi 12 mesi (si considera la data di dimissione) con Codice ICD-9_CM 250** (SDO).<br/><br/> <b>POLITERAPICI (VISTA)</b> - Pazienti che hanno ricevuto prescrizione (farmaceutica convenzionata) o consegna (farmaceutica diretta) nell'ultimo mese di più di 5 farmaci ( = 6 o più) appartenenti a distinte classi ATC4.<br/><br/> <b>SELEZIONE</b> - Quando è attiva la modalità “Selezione”, i dati mostrati sono relativi alla sola area selezionata: nel caso di “selezione esagonale” per patologia, i dati sono riferiti all'area inquadrata dall'esagono per quella patologia specifica; nel caso di “area irregolare di influenza delle strutture sanitarie”, i dati sono riferiti a tutti i pazienti contenuti in nell'area selezionata.<br/><br/> <b>FONTE:</b> database anonimizzati forniti da ASL4.<br/><br/> <b>ULTIMO AGGIORNAMENTO:</b> giugno 2022.</div>,
    },
};

  return (
    <div>
      <BsInfoCircle color="#84817a" style={{ margin: "5px", marginRight: "10px", marginTop: "10px", float: "right" }} cursor = "pointer" onClick={() => handleInfoClick(indicatorsInfo['informazioni-dati'].infoText, indicatorsInfo['informazioni-dati'].title)}/>
      <InfoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <table style={{marginTop:10, marginBottom:10, width:250, borderCollapse: 'collapse'}}>
        <tbody>
            
            <tr>
            <td colSpan={4}>
                <Typography variant="h4" align="center" color="darkblue">
                {FormatNumber(stats.totale)}
                </Typography>
            </td>
            </tr>
            <tr>
            <td colSpan={4}>
                <Typography variant="subtitle2" align="center" color="darkblue">
                totale {title}
                </Typography>
            </td>
            </tr>
            <tr>
            <td style={{width:60}}>&nbsp;
            </td>
            <td style={{width:65, borderRight:'2px solid grey', borderBottom: '2px solid grey'}}>
            </td>
            <td style={{width:65, borderLeft:'2px solid grey', borderBottom: '2px solid grey'}}>
            </td>
            <td style={{width:60}}>
            </td>
            </tr>
            <tr>
            <td>&nbsp;
            </td>
            <td style={{borderLeft:'2px solid grey'}}>
            </td>
            <td style={{borderRight:'2px solid grey'}}>
            </td>
            <td>
            </td>
            </tr>
            <tr>
            <td colSpan={2}>
                <Typography variant="h5" align="center" color="#8884d8">
                {FormatNumber(stats.sesso_f)}
                </Typography>
            </td>
            <td colSpan={2}>
                <Typography variant="h5" align="center" color="#82ca9d">
                {FormatNumber(stats.sesso_m)}
                </Typography>
            </td>
            </tr>
            <tr>
            <td colSpan={2}>
                <Typography variant="subtitle2" align="center" color="#8884d8">
                femmine
                </Typography>
            </td>
            <td colSpan={2}>
                <Typography variant="subtitle2" align="center" color="#82ca9d">
                maschi
                </Typography>
            </td>
            </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PatientCount;
